import { cn } from "@theprelude/core";
import { InputHTMLAttributes } from "react";

export type RadioProps = InputHTMLAttributes<HTMLInputElement>;

export const Radio: React.FC<RadioProps> = ({ className, type, ...props }) => {
  type;

  return (
    <input
      className={cn(
        "checked:after:-translate-x-1/2 checked:after:-translate-y-1/2 relative size-4 appearance-none rounded-full border border-stroke-input bg-primary-background checked:bg-blue-bay checked:after:absolute checked:after:top-2/4 checked:after:left-2/4 checked:after:size-1.5 checked:after:rounded-full checked:after:bg-white checked:after:content-['']",
        className,
      )}
      type="radio"
      {...props}
    />
  );
};
